/* DIY Printz Studio page effects: reveal, timer, scan, compare, copy. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal(root) {
    var els = root.querySelectorAll('[data-dps-reveal]:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          var d = parseInt(en.target.getAttribute('data-dps-delay') || '0', 10);
          setTimeout(function () { en.target.classList.add('is-in'); }, d);
          io.unobserve(en.target);
        }
      });
    }, { threshold: 0.15 });
    els.forEach(function (e) { io.observe(e); });
  }

  function toSecs(t) { var p = String(t).split(':').map(Number); var s = 0; p.forEach(function (n) { s = s * 60 + (n || 0); }); return s; }
  function fmt(s) { var h = Math.floor(s / 3600), m = Math.floor(s % 3600 / 60), x = Math.floor(s % 60); return [h, m, x].map(function (n) { return n < 10 ? '0' + n : '' + n; }).join(':'); }

  function timers(root) {
    root.querySelectorAll('[data-dps-count]').forEach(function (el) {
      if (el.__dps) return; el.__dps = 1;
      var target = toSecs(el.getAttribute('data-dps-count'));
      var run = function () {
        if (reduce) { el.textContent = fmt(target); return; }
        var t0 = performance.now(), dur = 1600;
        (function step(now) {
          var k = Math.min(1, (now - t0) / dur); k = 1 - Math.pow(1 - k, 3);
          el.textContent = fmt(Math.round(target * k));
          if (k < 1) requestAnimationFrame(step);
        })(t0);
      };
      if (!('IntersectionObserver' in window)) { run(); return; }
      el.textContent = fmt(0);
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { run(); io.disconnect(); } }, { threshold: 0.5 });
      io.observe(el);
    });
  }

  function scans(root) {
    root.querySelectorAll('[data-dps-scan]').forEach(function (st) {
      if (st.__dps) return; st.__dps = 1;
      var pct = st.querySelector('.dps-scan__pct');
      var speed = parseFloat(st.getAttribute('data-speed') || '5') * 1000;
      var hover = false, start = performance.now(), visible = true;
      function set(v) { st.style.setProperty('--scan', v.toFixed(1) + '%'); if (pct) pct.textContent = Math.round(v) + '%'; }
      if (reduce) { set(100); }
      function loop(now) {
        if (!hover && visible && !reduce) {
          var t = ((now - start) % (speed * 2)) / speed; // 0..2
          var v = t < 1 ? t : 2 - t;
          v = v < 0.5 ? 2 * v * v : 1 - Math.pow(-2 * v + 2, 2) / 2;
          set(v * 100);
        }
        requestAnimationFrame(loop);
      }
      requestAnimationFrame(loop);
      if ('IntersectionObserver' in window) new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }).observe(st);
      function fromEvent(e) { var r = st.getBoundingClientRect(); var x = (e.touches ? e.touches[0].clientX : e.clientX) - r.left; set(Math.max(0, Math.min(100, x / r.width * 100))); }
      st.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') hover = true; });
      st.addEventListener('pointermove', function (e) { if (e.pointerType === 'mouse' || e.buttons) { hover = true; fromEvent(e); } });
      st.addEventListener('pointerleave', function () { hover = false; start = performance.now(); });
      st.addEventListener('touchmove', function (e) { hover = true; fromEvent(e); }, { passive: true });
      st.addEventListener('touchend', function () { setTimeout(function () { hover = false; start = performance.now(); }, 1500); });
    });
  }

  function compares(root) {
    root.querySelectorAll('[data-dps-cmp]').forEach(function (c) {
      if (c.__dps) return; c.__dps = 1;
      var input = c.querySelector('input');
      var upd = function () { c.style.setProperty('--pos', input.value + '%'); };
      input.addEventListener('input', upd); upd();
      c.addEventListener('pointermove', function (e) {
        if (e.pointerType !== 'mouse' || e.buttons) return;
        if (c.getAttribute('data-hover') !== 'true') return;
        var r = c.getBoundingClientRect(); input.value = Math.round((e.clientX - r.left) / r.width * 100); upd();
      });
    });
  }

  function copies(root) {
    root.querySelectorAll('[data-dps-copy]').forEach(function (b) {
      if (b.__dps) return; b.__dps = 1;
      b.addEventListener('click', function () {
        var code = b.parentNode.querySelector('code'); var txt = code ? code.innerText : '';
        var done = function () { var o = b.textContent; b.textContent = b.getAttribute('data-done') || 'Copied'; setTimeout(function () { b.textContent = o; }, 1600); };
        if (navigator.clipboard) navigator.clipboard.writeText(txt).then(done, done);
        else { var t = document.createElement('textarea'); t.value = txt; document.body.appendChild(t); t.select(); try { document.execCommand('copy'); } catch (e) {} t.remove(); done(); }
      });
    });
  }

  function init(root) { root = root || document; reveal(root); timers(root); scans(root); compares(root); copies(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
